import { render } from "./TableDemo.vue?vue&type=template&id=79a0f69b&scoped=true"
import script from "./TableDemo.vue?vue&type=script&lang=js"
export * from "./TableDemo.vue?vue&type=script&lang=js"

import "./TableDemo.vue?vue&type=style&index=0&id=79a0f69b&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a0f69b"]])

export default __exports__